module.exports = __webpack_public_path__ + "img/11m1.c9cecc27.jpg";